import { Alert, Form, Modal, Spin,notification } from 'antd'
import { FormComponentProps } from 'antd/lib/form'
import autobind from 'autobind-decorator'
import * as React from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { connect } from 'redux-scaffolding-ts'
import { IdentityProps, withIdentity } from 'src/core/services/authentication'
import { formatMessage } from 'src/core/services/http.service'
import { NewRestrictionPlanItem, NewRestrictionPlanStore } from 'src/stores/restriction-plans-store'
import { RestrictionPlanFormBody } from './restriction-plan-form'
import { formItemToRestrictionPlanItem, RestrictionPlanFormItem } from './utils'
import {UserProfileProps, withUserProfile} from "../../../components/user-profile";

interface NewRestrictionPlanViewState {
	restrictionPlanFormItem: RestrictionPlanFormItem
}

interface NewRestrictionPlanViewProps extends UserProfileProps {
	companyId: string
	onClose: (id: string | undefined, item?: NewRestrictionPlanItem) => void
}

@connect(['newRestrictionPlan', NewRestrictionPlanStore])
class NewRestrictionPlanView extends React.Component<
	NewRestrictionPlanViewProps & WithTranslation & FormComponentProps,
	NewRestrictionPlanViewState
> {
	private get NewRestrictionPlanStore() {
		return (this.props as any).newRestrictionPlan as NewRestrictionPlanStore
	}

	constructor(props: NewRestrictionPlanViewProps & WithTranslation & FormComponentProps) {
		super(props)
		this.state = {
			restrictionPlanFormItem: {
				displayName: '',
				hourRestrictions: {
					minhours: [0, 0, 0, 0, 0, 0, 0, 0],
					maxhours: [24, 24, 24, 24, 24, 0, 0, 120]
				}
			}
		}
		this.NewRestrictionPlanStore.createNew({} as any)
		this.NewRestrictionPlanStore.changeUrl(this.props.companyId)
	}

	componentWillReceiveProps(nextProps: NewRestrictionPlanViewProps) {
		if (
			this.NewRestrictionPlanStore.state.result &&
			this.NewRestrictionPlanStore.state.result.isSuccess
		)
			nextProps.onClose(
				(this.NewRestrictionPlanStore.state.result as any).aggregateId,
				this.NewRestrictionPlanStore.state.item
			)
	}

	@autobind
	private countDownNotification(_notification: any, message: string, description: string, key: string) {
		let secondsToGo = 4;
		_notification({
			key: key,
			message: message + `(${secondsToGo}).`,
			description: description
		});
		const timer = setInterval(() => {
			secondsToGo -= 1;
			_notification({
				key: key,
				message: message + `(${secondsToGo}).`,
				description: description,
				onClose: () => clearInterval(timer),
			});
		}, 1000);
		setTimeout(() => {
			clearInterval(timer);
			notification.close(key);
		}, secondsToGo * 1000);
	}

	@autobind
	private onCreateNewItem() {
		const {t} = this.props
		return new Promise((resolve, reject) => {
			this.props.form.validateFields(event => {
				var values = this.props.form.getFieldsValue()
				if (!event) {
					const itemFromValues = {
						...formItemToRestrictionPlanItem(values),
						companyId: this.props.companyId
					}
					this.NewRestrictionPlanStore.change(itemFromValues)
					this.NewRestrictionPlanStore.submit().then(result => {
						if (result.isSuccess) {
							resolve()
							this.countDownNotification(notification.success,t('Success'),t('Working Regime added successfully'),'success')

						} else {
							reject()
							this.countDownNotification(notification.success, t('Error'), t('There was an error'), 'fail')
						}
						this.NewRestrictionPlanStore.clear()
					})
				}
			})
		})
	}

	@autobind
	private onCancelNewItem() {
		this.NewRestrictionPlanStore.clear()
		this.props.onClose(undefined)
	}

	public render() {
		const { getFieldDecorator, setFieldsValue } = this.props.form
		const { t, i18n, tReady } = this.props
		return (
			<Modal
				maskClosable={false}
				visible
				onCancel={this.onCancelNewItem}
				onOk={this.onCreateNewItem}
				closable={false}
				width="800px"
				okText={t("OK")}
				cancelText={t("Cancel")}
				title={t('New Restriction Plan')}>
				{this.NewRestrictionPlanStore.state.result &&
					!this.NewRestrictionPlanStore.state.result.isSuccess && (
						<Alert
							type="error"
							message={t('An error has occurred')}
							description={formatMessage(this.NewRestrictionPlanStore.state.result)}
						/>
					)}
				<div style={{ display: 'flex', justifyContent: 'center' }}>
					<Spin spinning={this.NewRestrictionPlanStore.state.isBusy}>
						<Form id="restrictionPlanCreationForm" onKeyUp={(e) => { if (e.keyCode === 13 && this.onCreateNewItem) { this.onCreateNewItem(); } }} onSubmit={this.onCreateNewItem}>
							<RestrictionPlanFormBody
								item={this.state.restrictionPlanFormItem}
								getFieldDecorator={getFieldDecorator}
								i18n={i18n}
								t={t}
								tReady={tReady}
							/>
						</Form>
					</Spin>
				</div>
			</Modal>
		)
	}
}

// Wire up the React component to the Redux store
export default ( withUserProfile(withTranslation()(
	withIdentity(Form.create({})(NewRestrictionPlanView as any) as any)
)) as any) as React.ComponentClass<NewRestrictionPlanViewProps>
